import { Spinner } from '@/components/ui/spinner';

export interface ReconnectingBannerProps {
  /** The line to show: "Reconnecting…", or the rate-limit one. */
  message: string;
}

/**
 * The page-level status bar (offline, BFF unreachable, 429): slim, one line, aligned to the 760px chat column
 * above the scroller, so it never covers the conversation. A status region, so a screen reader hears it once.
 */
export function ReconnectingBanner({ message }: ReconnectingBannerProps) {
  return (
    <div className="mx-auto w-full max-w-[760px] shrink-0 px-6 pt-3">
      <div
        role="status"
        className="flex items-center gap-2 rounded-md border border-ds-hairline bg-ds-ink-a05 px-3 py-1.5 text-label text-ds-text-2"
      >
        <Spinner size="sm" />
        <span>{message}</span>
      </div>
    </div>
  );
}
